import {
    apiRequest,
    hukumanDetail
} from "../../../../../services/adapters/kepegawaian/hukumanService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", hukumanDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository